import React from 'react';
import { SearchField } from '@backstage/ui';
import { useSearch } from '@backstage/plugin-search-react';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../../core/i18n';

interface SearchBarProps {
  placeholder?: string;
  autoFocus?: boolean;
}

export const SearchBar = ({ placeholder, autoFocus }: SearchBarProps) => {
  const { term, setTerm } = useSearch();
  const { t } = useTranslationRef(appTranslationRef);
  const [inputValue, setInputValue] = React.useState(term);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setTerm(inputValue);
    }, 300);
    return () => clearTimeout(timer);
  }, [inputValue, setTerm]);

  // Sync external term changes (e.g. from URL)
  React.useEffect(() => {
    setInputValue(term);
  }, [term]);

  return (
    <SearchField
      placeholder={placeholder ?? t('search.searchPlaceholder')}
      value={inputValue}
      onChange={setInputValue}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
      size='medium'
      aria-label={placeholder ?? t('search.searchPlaceholder')}
    />
  );
};
